import React from 'react';
import { Helmet } from 'react-helmet';
import { Row, Col } from '@elevationscu/ui-component-lib';
import styles from './ProgressBar.module.scss';

export default function ProgressBar({ pageNumber, maxPages }) {
  const totalPages = 3;
  // eslint-disable-next-line no-unused-vars
  const [title, setTitle] = React.useState(`Request a business home equity line of credit - Page ${pageNumber} | Elevations Credit Union`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Row
        tabindex="0"
        role="progressbar"
        aria-valuemax={maxPages}
        aria-valuenow={pageNumber}
        aria-valuetext={`Page ${pageNumber} of ${maxPages}`}
      >
        {Array(totalPages).fill(0).map((value, index) => (
          <Col key={`progress-${index + 1}`} className={index < pageNumber ? styles.currentProgress : styles.progressStyle}>
            <svg width="250" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <rect
                className={index < pageNumber ? styles.currentProgressSvg : styles.emptyProgressSvg}
                x="0"
                y="0"
                width="250"
                height="13"
              />
            </svg>
          </Col>
        ))}
      </Row>
    </>
  );
}
